import SalesList from '@/screens/sales/List'
import PayOrder from '@/screens/sales/PayOrder'
import SalesBalance from '@/screens/sales/Balance'

import auth from './middleware/auth'

const routes = [
  {
    name: 'SalesList',
    component: SalesList,
    path: '/sales',
    meta: {
      requireAuth: true,
      permissions: ['manager', 'buyer'],
      middleware: { auth }
    }
  },
  {
    name: 'SalesBalance',
    component: SalesBalance,
    path: '/sales-balance',
    meta: {
      requireAuth: true,
      permissions: ['manager', 'seller'],
      middleware: { auth }
    }
  },
  {
    name: 'PayOrder',
    component: PayOrder,
    path: '/:restaurantSlug/orders/:id'
  }
]

export default routes
